// reducers/index.js
import { combineReducers } from '@reduxjs/toolkit';
import doctorReducer from './doctorReducer';
import userReducer from './userReducer';
import templateReducer from './templateReducer';
import messageReducer from './message.Reducer';

const rootReducer = combineReducers({
  doctor: doctorReducer,
  template: templateReducer,
  user: userReducer,
  message: messageReducer,
  // Add other reducers here
});

export default rootReducer;
